import { useEffect, useRef } from "react";
import { useAIChat } from "~/lib/hooks/useAIChat";
import { SUGGESTED_PROMPTS } from "~/lib/ai/cannedReplies";
import { Message } from "./Message";
import { Composer } from "./Composer";

export function ChatPanel() {
  const { messages, isStreaming, send, reset } = useAIChat({ mode: "live" });
  const scrollRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.scrollTo({ top: el.scrollHeight, behavior: "smooth" });
  }, [messages]);

  const hasUserMessage = messages.some((m) => m.role === "user");

  return (
    <div className="mx-auto flex w-full max-w-3xl flex-col gap-4 px-4">
      <div
        ref={scrollRef}
        className="flex max-h-[55vh] min-h-[280px] flex-col gap-3 overflow-y-auto rounded-2xl border border-jg-border bg-jg-bg-soft/30 p-4 sm:max-h-[60vh]"
      >
        {messages.map((m) => (
          <Message key={m.id} message={m} />
        ))}
      </div>

      {!hasUserMessage && (
        <ul className="flex flex-wrap gap-2">
          {SUGGESTED_PROMPTS.map((p) => (
            <li key={p}>
              <button
                type="button"
                onClick={() => send(p)}
                disabled={isStreaming}
                className="rounded-full border border-jg-border bg-jg-bg-soft/40 px-3 py-1 text-xs text-jg-fg-muted transition-colors hover:border-jg-ai/50 hover:text-jg-fg disabled:opacity-40"
              >
                {p}
              </button>
            </li>
          ))}
        </ul>
      )}

      <Composer
        disabled={isStreaming}
        onSend={send}
        placeholder={
          isStreaming ? "Streaming reply…" : "Ask about JGson, or pick a suggestion"
        }
      />

      <div className="flex items-center justify-between px-1 text-xs text-jg-fg-muted">
        <p>
          <span className="mr-1.5 inline-block size-1.5 rounded-full bg-jg-ai align-middle" />
          Live · Gemini Flash via the JGson Hono backend (rate-limited)
        </p>
        {hasUserMessage && (
          <button
            type="button"
            onClick={reset}
            className="rounded-full border border-jg-border px-2.5 py-0.5 hover:text-jg-fg"
          >
            Reset
          </button>
        )}
      </div>
    </div>
  );
}
